export const datePickerPreset = {
  datepicker: {
    date: {
      selectedBackground: 'var(--brand--50)',
      rangeSelectedBackground: 'var(--brand--5)',
      rangeSelectedColor: 'var(--neutral--60)',
    },
    inputIcon: {
      color: 'var(--neutral--40)',
    },
    css: () => `
      .p-datepicker-input-icon-container {
        inset-inline-start: var(--p-form-field-padding-x);
      }

      .p-datepicker input {
        width: 100%;
        padding-left: 2rem;
      }

      .p-datepicker-day-selected-range {
        border-radius: 8px;
      }
    `,
  },
};
